import React, { useEffect, useState } from 'react';
import styles from "./styles/regularmeal.module.css";
import { LocalizationProvider, StaticDatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import koLocale from 'date-fns/locale/ko'
import { Backdrop, Chip, CircularProgress, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Button } from '@mui/joy';
import { getFetch, postFetch } from '../../../../fetch/fetch';
import totalLocationData from '../../../../data/locationdata';
import RegularMealSettingModal from './regularmealsettingmodal';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { da } from 'date-fns/locale';
import { CatchingPokemonSharp } from '@mui/icons-material';



const RegularMeal: React.FC<any> = (props) => {

    const [dateValue, setDateValue] = useState<Date>(new Date());
    const [minDate, setMinDate] = useState<Date>(new Date());
    const [data, setData] = useState<any>();
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedLocations, setSelectedLocations] = useState<string[]>([]);
    const [savedLocations, setSavedLocations] = useState<string[]>([]);
    const [mode, setMode] = useState<"save" | "view">("save");
    const [viewLocation, setViewLocation] = useState<string>("");
    const [settingModalOpen, setSettingModalOpen] = useState<boolean>(false);

    //정기식 운영 지점 목록 (체크박스 후보)
    const locationCandidates = totalLocationData.filter((each) => props.user && each.academy.includes(props.user.academy) && each.needRegularMeal);

    const notify1 = () => toast.success("저장 성공!", {
            position : "bottom-right",
            autoClose : 3000,
            hideProgressBar : true,
            theme : "light"
    });

    const notify2 = () => toast.error("저장 실패!", {
        position : "bottom-right",
        autoClose : 3000,
        hideProgressBar : true,
        theme : "light"
    });

    const notify3 = () => toast.error("지점을 선택해주세요!", {
        position : "bottom-right",
        autoClose : 3000,
        hideProgressBar : true,
        theme : "light"
    });

    const makeInitialData = () => {

        const initialData = [];

        for (let i = 0; i < 6; i++) {
            const oneRow = {
                lunch: ["", "", "", "", "", "", "", ""],
                dinner: ["", "", "", "", "", "", "", ""]
            }

            initialData.push(oneRow);
        }

        return initialData;
    }

    useEffect(() => {

        const initialData = makeInitialData();

        setData([...initialData]);

        getData();

    }, [dateValue, mode, viewLocation]);

    useEffect(() => {

        //조회 모드 지점 radio 기본값 - 첫 후보 지점
        if (!viewLocation && locationCandidates.length > 0) {
            setViewLocation(locationCandidates[0].english);
        }

    }, [props.user]);

    useEffect(() => {

        //dateValue를 다음 주 월요일로 설정
        const today = new Date().getDay();

        if (today === 1) {
            return;
        }

        const diff = 1 - today;

        const nextMonday = new Date();
        nextMonday.setDate(nextMonday.getDate() + diff + 7);

        setDateValue(nextMonday);

    }, []);


    const disableExceptMonday = (date: Date) => {
        return date.getDay() !== 1;
    }

    const handleChange = (dateIndex : number, lunchOrDinner : string, mealIndex : number, value: string) => {

        const newData = [...data];
        newData[dateIndex][lunchOrDinner][mealIndex] = value;

        setData(newData);

    }

    const pasteFromClipboard = async () => {

        try {
            const text = await navigator.clipboard.readText();

            console.log(text);
            
            const lines = text
        .split(/\r?\n/)          // \r\n(윈도우) or \n(맥/리눅스) 대응
        .map(line => line.trim()) 

        const cleanedArray = lines.map(item =>
            item
              // 1) 영문 괄호(`(` `)`) 내용 제거
              .replace(/\([^)]*\)/g, "")
              // 2) 전각 괄호(`（` `）`) 내용 제거
              .replace(/（[^）]*）/g, "")
              .trim()
          );

            console.log(cleanedArray);

            makeLinesToData(cleanedArray);

          } catch (err) {
            console.error("Failed to read clipboard contents: ", err);
          }

    }

    const makeLinesToData = (lines: string[]) => {

        const initialData = makeInitialData();

        //끼니당 행 수를 전체 줄 수로 판정 (6일 × 2끼 = 12로 나눔, 최대 8행)
        const rowsPerMeal = Math.min(8, Math.max(1, Math.round(lines.length / 12)));
        const lunchLineCount = rowsPerMeal * 6;

        lines.forEach((line, index) => {

            var lunchOrDinner : "lunch" | "dinner" = index < lunchLineCount ? "lunch" : "dinner";
            const targetIndex = index < lunchLineCount ? index : index - lunchLineCount;

            const dateIndex = targetIndex % 6;
            const mealIndex = Math.floor(targetIndex / 6);

            if (mealIndex >= 8) {
                return;
            }

            initialData[dateIndex][lunchOrDinner][mealIndex] = line;

        });

        console.log(initialData);

        setData([...initialData]);

    }

    const getData = async () => {

        try{

            const targetTime = dateValue.getTime();

            //qeurystring으로 get으로 요청

            var url = `/dashboard/restaurant/regularmeal/getForTeacher?time=${targetTime}`;

            //조회 모드는 선택한 지점 기준으로 불러오기
            if(locationCandidates.length > 0 && mode === "view" && viewLocation){
                url += `&location=${viewLocation}`;
            }

            const result : any = await getFetch(url);

            if(result.message === "success") {

                //이번 주에 업로드된 지점 목록 갱신
                if(result.savedLocations){
                    setSavedLocations(result.savedLocations);
                }else{
                    setSavedLocations([]);
                }

                //저장 모드에서는 식단표를 불러와 채우지 않음
                if(locationCandidates.length > 0 && mode === "save"){
                    return;
                }

                //조회 모드인데 지점 선택 전이면 채우지 않음
                if(locationCandidates.length > 0 && mode === "view" && !viewLocation){
                    return;
                }

                if(!result.data) {
                    return;
                }

                //예전 7칸 데이터도 8칸 폼에 맞게 패딩
                const newData = result.data.data;

                if(!newData){
                    return;
                }

                newData.forEach((eachDay : any) => {

                    ["lunch", "dinner"].forEach((mealType) => {

                        if(!eachDay[mealType]){
                            eachDay[mealType] = [];
                        }

                        while(eachDay[mealType].length < 8){
                            eachDay[mealType].push("");
                        }

                        eachDay[mealType] = eachDay[mealType].slice(0, 8);

                    });

                });

                setData([...newData]);
            }

        }catch(e){
            console.error(e);
        }

    }

    const handleLocationChange = (checked : boolean, english : string) => {

        if(checked){
            setSelectedLocations([...selectedLocations, english]);
        }else{
            setSelectedLocations(selectedLocations.filter((each) => each !== english));
        }

    }

    const submit = async () => {

        if (!data) {
            return;
        }

        //지점 후보가 있는데 하나도 선택 안 했으면 저장 차단
        if (locationCandidates.length > 0 && mode === "save" && selectedLocations.length === 0) {
            notify3();
            return;
        }

        if (locationCandidates.length > 0 && mode === "view" && !viewLocation) {
            notify3();
            return;
        }

        try {

            setLoading(true);

            const targetTime = dateValue.getTime();

            const sendData : any = {
                time: targetTime,
                data: data
            }

            //지점 후보가 있는 학원만 locations 전송 (없으면 기존 방식 저장)
            //조회 모드는 보고 있는 지점 하나만 갱신
            if (locationCandidates.length > 0) {
                sendData.locations = mode === "view" ? [viewLocation] : selectedLocations;
            }

            const result : any = await postFetch("/dashboard/restaurant/regularmeal/submit", sendData);

            if(result.message === "success") {
                notify1();
                //방금 업로드한 지점이 파란색으로 바로 표시되게 재조회
                getData();
            }else{
                new Error("error");
            }

            setLoading(false);

        } catch (e) {
            notify2();
        }

    }

    return (
        <div>
            <div className={styles.btnsDiv}>
                {
                    locationCandidates.length > 0 &&
                    <Button variant="soft" color="neutral" sx={{ marginRight: "8px" }} onClick={() => setSettingModalOpen(true)}>
                        가격·노출 설정
                    </Button>
                }
                <Button variant="soft" color="primary" onClick={pasteFromClipboard}>
                    클립보드 붙여넣기
                </Button>
            </div>
            <RegularMealSettingModal
                open={settingModalOpen}
                handleClose={() => setSettingModalOpen(false)}
                locationCandidates={locationCandidates}
                user={props.user}
            />
            {
                locationCandidates.length > 0 &&
                <div className={styles.locationDiv}>
                    <div className={styles.modeDiv}>
                        <ToggleButtonGroup
                            value={mode}
                            exclusive
                            size="small"
                            onChange={(e, newMode) => {
                                if (newMode) {
                                    setMode(newMode);
                                }
                            }}
                        >
                            <ToggleButton value="save" sx={{ width: "80px" }}>저장</ToggleButton>
                            <ToggleButton value="view" sx={{ width: "80px" }}>조회</ToggleButton>
                        </ToggleButtonGroup>
                    </div>
                    <div className={styles.chipsDiv}>
                        {
                            locationCandidates.map((eachLocation, index) => {

                                const isSaved = savedLocations.includes(eachLocation.korean);
                                const isSelected = mode === "save" ? selectedLocations.includes(eachLocation.english) : viewLocation === eachLocation.english;

                                return (
                                    <Chip key={index} label={eachLocation.korean} clickable variant="outlined"
                                        onClick={() => {
                                            if (mode === "save") {
                                                handleLocationChange(!isSelected, eachLocation.english);
                                            } else {
                                                setViewLocation(eachLocation.english);
                                            }
                                        }}
                                        sx={{
                                            color: isSaved ? "#1976d2" : "#d32f2f",
                                            backgroundColor: isSelected ? "rgba(25, 118, 210, 0.12)" : "transparent",
                                            border: isSelected ? "1.5px solid #1976d2" : "1px solid rgba(0, 0, 0, 0.23)",
                                            fontSize: "14px"
                                        }}
                                    />
                                )
                            })
                        }
                    </div>
                    <div className={styles.locationLegend}>
                        {
                            mode === "save" ?
                            <>지점명 <span style={{ color: "#1976d2" }}>파란색</span> : 이번 주 메뉴 업로드됨 / <span style={{ color: "#d32f2f" }}>빨간색</span> : 미업로드 · 체크한 지점들에 메뉴가 저장됩니다</>
                            :
                            <>지점명 <span style={{ color: "#1976d2" }}>파란색</span> : 이번 주 메뉴 업로드됨 / <span style={{ color: "#d32f2f" }}>빨간색</span> : 미업로드 · 지점과 날짜를 선택하면 저장된 식단표가 표시됩니다 · 수정 후 저장하면 이 지점만 갱신됩니다</>
                        }
                    </div>
                </div>
            }
            <div className={styles.container}>
                <div className={styles.calendarDiv}>
                    <LocalizationProvider locale={koLocale} dateAdapter={AdapterDateFns}>
                        <StaticDatePicker
                            shouldDisableDate={disableExceptMonday}
                            displayStaticWrapperAs="desktop"
                            openTo="day"
                            value={dateValue}
                            // disablePast
                            //minDate={minDate}
                            onChange={(newValue: any) => {
                                setDateValue(newValue);
                            }}
                            renderInput={(params: any) => <TextField {...params} />}
                        />
                    </LocalizationProvider>
                </div>
                <div className={styles.tableDiv}>
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th></th>
                                {
                                    new Array(6).fill(0).map((_, index) => {

                                        const targetDate = new Date(dateValue);
                                        targetDate.setDate(targetDate.getDate() + index);

                                        const month = targetDate.getMonth() + 1;
                                        const monthString = month < 10 ? `0${month}` : `${month}`;

                                        const date = targetDate.getDate();
                                        const dateString = date < 10 ? `0${date}` : `${date}`;

                                        const day = targetDate.getDay();
                                        const dayString = ["일", "월", "화", "수", "목", "금", "토"][day];

                                        return (
                                            <th key={index}>
                                                <div>
                                                    {`${monthString}/${dateString} (${dayString})`}
                                                </div>
                                            </th>
                                        )

                                    })
                                }
                            </tr>
                            {
                                new Array(16).fill(0).map((_, rowIndex) => {
                                    return (
                                        <tr key={rowIndex} className={styles.rowStyle}>
                                            {
                                                new Array(7).fill(0).map((_, colIndex) => {

                                                    if (colIndex === 0 && (rowIndex === 0 || rowIndex === 8)) {
                                                        return (
                                                            <td key={colIndex} rowSpan={8} className={styles.mealType}>
                                                                {rowIndex === 0 ? "중식" : "석식"}
                                                            </td>
                                                        )
                                                    } else if (colIndex === 0) {
                                                        return;
                                                    }

                                                    const dateIndex = colIndex - 1;
                                                    const lunchOrDinner = rowIndex < 8 ? "lunch" : "dinner";
                                                    const mealIndex = rowIndex < 8 ? rowIndex : rowIndex - 8;

                                                    return (
                                                        <td key={colIndex}
                                                        className={`${rowIndex === 7 || rowIndex === 15 ? styles.lastRow : ""} ${styles.colStyle}`}
                                                        >
                                                            <div>
                                                                <input type="text" className={styles.inputStyle}
                                                                value={data ? data[dateIndex][lunchOrDinner][mealIndex] : ""}
                                                                onChange={(e) => handleChange(dateIndex, lunchOrDinner, mealIndex, e.target.value)}
                                                                />
                                                            </div>
                                                        </td>
                                                    )
                                                })
                                            }
                                        </tr>
                                    )

                                })
                            }
                        </thead>
                    </table>
                </div>
            </div>
            <div className={styles.submitBtnDiv}>
                <Button color="primary" size='lg' sx={{
                    width : "150px"
                }}
                onClick={submit}
                >
                    저장
                </Button>
            </div>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    )
}

export default RegularMeal;
